import { useState } from 'react';

interface CategoryItem {
  name: string;
  url: string;
  icon: string;
  imageUrl: string;
}

const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20sneakers%20and%20casual%20shoes%20arranged%20on%20a%20raw%20concrete%20studio%20floor%20with%20dramatic%20sunlight%20casting%20long%20shadows%2C%20industrial%20loft%20aesthetic%2C%20urban%20streetwear%20photography%2C%20textured%20concrete%20surface%2C%20bold%20contrast%20lighting%2C%20edgy%20modern%20atmosphere%2C%20high%20fashion%20editorial%20style%20with%20gritty%20urban%20backdrop&width=600&height=450&seq=cat-shoes-v2-2026&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodies%20draped%20over%20a%20rustic%20wooden%20bench%20in%20an%20autumn%20park%20setting%2C%20golden%20hour%20sunlight%20filtering%20through%20trees%2C%20fallen%20leaves%20scattered%20around%2C%20warm%20earthy%20orange%20and%20brown%20tones%2C%20relaxed%20outdoor%20lifestyle%20photography%2C%20soft%20bokeh%20background%2C%20comfortable%20casual%20fashion%20vibe&width=600&height=450&seq=cat-hoodies-v2-2026&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20graphic%20t-shirts%20hanging%20on%20a%20metal%20clothing%20rack%20against%20an%20exposed%20red%20brick%20wall%2C%20afternoon%20sun%20streaming%20through%20industrial%20windows%2C%20vintage%20boutique%20atmosphere%2C%20bohemian%20street%20style%2C%20textured%20wall%20and%20metal%20contrast%2C%20artistic%20clothing%20display%2C%20indie%20fashion%20store%20vibe&width=600&height=450&seq=cat-tshirts-v2-2026&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-archive-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20and%20denim%20jackets%20displayed%20on%20elegant%20wooden%20mannequins%20inside%20a%20modern%20boutique%20with%20soft%20ambient%20track%20lighting%2C%20dark%20moody%20interior%2C%20polished%20concrete%20floors%2C%20luxury%20retail%20atmosphere%2C%20rich%20texture%20details%20on%20collars%20and%20zippers%2C%20high-end%20fashion%20editorial%20photography&width=600&height=450&seq=cat-jackets-v2-2026&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Various%20styles%20of%20pants%20and%20shorts%20neatly%20stacked%20on%20reclaimed%20vintage%20wooden%20shelves%20inside%20a%20Scandinavian%20minimalist%20room%2C%20diffused%20northern%20light%20through%20large%20windows%2C%20muted%20sage%20green%20and%20oatmeal%20tones%2C%20serene%20organized%20interior%2C%20textile%20textures%20clearly%20visible%2C%20calm%20modern%20home%20aesthetic&width=600&height=450&seq=cat-pants-v2-2026&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-capsule-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20and%20beanies%20hanging%20on%20brass%20wall%20hooks%20against%20a%20dark%20charcoal%20painted%20accent%20wall%2C%20spotlight%20illumination%20from%20above%2C%20gallery-like%20presentation%2C%20dramatic%20shadows%2C%20premium%20headwear%20textures%2C%20contemporary%20urban%20boutique%20display%2C%20sophisticated%20streetwear%20curation&width=600&height=450&seq=cat-headwear-v2-2026&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20clothing%20sets%20in%20a%20creative%20flat%20lay%20composition%20on%20a%20polished%20marble%20surface%20with%20scattered%20eucalyptus%20leaves%20and%20dried%20flowers%2C%20top-down%20perspective%2C%20bright%20natural%20window%20light%2C%20elegant%20soft%20pastels%20mixed%20with%20earth%20tones%2C%20artistic%20fashion%20styling%2C%20high-end%20editorial%20catalog%20photography&width=600&height=450&seq=cat-sets-v2-2026&orientation=landscape',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20delicately%20folded%20inside%20an%20open%20vintage%20wooden%20dresser%20drawer%2C%20gentle%20morning%20sunlight%20peeking%20through%20sheer%20linen%20curtains%2C%20intimate%20bedroom%20atmosphere%2C%20warm%20honey%20and%20cream%20tones%2C%20natural%20fabric%20textures%2C%20peaceful%20morning%20routine%20aesthetic%2C%20spa-like%20serenity&width=600&height=450&seq=cat-underwear-v2-2026&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jerseys%20hanging%20inside%20an%20athletic%20locker%20room%20with%20metal%20lockers%20in%20background%2C%20bright%20stadium-style%20overhead%20lighting%2C%20dynamic%20sporty%20atmosphere%2C%20vibrant%20team%20colors%2C%20moisture-wicking%20fabric%20texture%20visible%2C%20pre-game%20preparation%20energy%2C%20authentic%20athletic%20environment%20photography&width=600&height=450&seq=cat-jersey-v2-2026&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-bubble-chart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20including%20watches%20bracelets%20and%20sunglasses%20displayed%20inside%20a%20glass%20jewelry%20showcase%20with%20soft%20LED%20accent%20lighting%20reflections%2C%20luxury%20department%20store%20setting%2C%20dark%20navy%20velvet%20lining%2C%20sparkling%20metallic%20surfaces%2C%20sophisticated%20retail%20display%2C%20high-end%20shopping%20atmosphere&width=600&height=450&seq=cat-accessories-v2-2026&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20handbags%20and%20backpacks%20hanging%20on%20a%20sculptural%20brass%20coat%20stand%20in%20a%20bright%20entryway%20with%20arched%20doorway%20and%20terrazzo%20flooring%2C%20Mediterranean%20villa%20aesthetic%2C%20warm%20afternoon%20light%2C%20textured%20leather%20and%20canvas%20surfaces%2C%20elegant%20home%20interior%2C%20sophisticated%20lifestyle%20photography&width=600&height=450&seq=cat-bags-v2-2026&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20rolled%20and%20displayed%20on%20a%20weathered%20workbench%20inside%20an%20artisan%20leather%20workshop%2C%20tools%20and%20leather%20scraps%20scattered%20naturally%2C%20warm%20tungsten%20workshop%20lighting%2C%20rich%20cognac%20and%20tobacco%20leather%20tones%2C%20traditional%20craftsmanship%20atmosphere%2C%20authentic%20maker%20space%20photography&width=600&height=450&seq=cat-belts-v2-2026&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artisan%20fragrance%20bottles%20arranged%20on%20a%20vintage%20mirrored%20tray%20with%20flickering%20candlelight%20creating%20warm%20reflections%20and%20ambiance%2C%20dark%20sensual%20evening%20setting%2C%20cut%20glass%20and%20crystal%20details%20sparkling%2C%20mysterious%20sophisticated%20atmosphere%2C%20luxury%20perfume%20boutique%2C%20sensual%20amber%20and%20gold%20tones%2C%20high-end%20fragrance%20photography&width=600&height=450&seq=cat-perfumes-v2-2026&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20products%20including%20electronics%20gadgets%20home%20decor%20and%20stationery%20spread%20across%20a%20rustic%20farmhouse%20dining%20table%2C%20morning%20sunlight%20streaming%20in%2C%20cozy%20lived-in%20atmosphere%2C%20diverse%20textures%20from%20metal%20to%20ceramic%20to%20paper%2C%20modern%20country%20aesthetic%2C%20curated%20personal%20collection%20photography&width=600&height=450&seq=cat-other-v2-2026&orientation=landscape',
  },
];

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCategory(value);
    if (value) {
      window.open(value, '_blank', 'noopener,noreferrer');
      setSelectedCategory('');
    }
  };

  return (
    <section id="categories" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1300px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-xs font-medium text-primary-500 tracking-widest uppercase">
              Browse Products
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-3">
              Shop by{' '}
              <span className="text-primary-500">Category</span>
            </h2>
            <p className="text-foreground-500 mt-2 max-w-md text-sm">
              Select a category below or use the dropdown to jump directly to any product section on our main website.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">Quick Jump:</span>
            <div className="relative">
              <select
                value={selectedCategory}
                onChange={handleDropdownChange}
                className="appearance-none bg-background-100 border border-background-200 rounded-xl px-5 py-3 pr-12 text-sm text-foreground-700 cursor-pointer focus:outline-none focus:border-primary-300 transition-colors min-w-[220px]"
              >
                <option value="">All Categories</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-400 pointer-events-none w-5 h-5 flex items-center justify-center text-sm"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-2xl overflow-hidden card-hover cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex items-center justify-between">
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                  <p className="text-xs text-foreground-400 mt-1">View products &rarr;</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50 text-foreground-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}